import api from './api';

export const getEmailKeys = () => api.get('/admin/email/keys');

export const sendEmail = (payload) => api.post(`admin/email/send`, { ...payload });
